export default "__VITE_ASSET__CN0BuSmj__"